module.exports = __webpack_public_path__ + "img/health.12ee89d8.png";